import { I18n } from 'react-redux-i18n';
import React from 'react';
import { MultiChipDropdown } from '../../components/V2ContextBar';

type MarketOption = { value: string; label: string };

interface MarketControlProps {
  options: MarketOption[];
  selected: MarketOption[];
  disabled: boolean;
  onChange: (markets: MarketOption[]) => void;
}

export const MarketControl: React.FC<MarketControlProps> = ({
  options,
  selected,
  disabled,
  onChange
}) => {
  const placeholder = I18n.t('v2GlobalView.contextBar.marketPlaceholder');
  return (
    <MultiChipDropdown
      options={options}
      selected={selected}
      onChange={onChange}
      placeholder={placeholder}
      showAllOption={false}
      variant="dark"
      neutral
      disabled={disabled}
    />
  );
};
